<template lang="pug">
    div
        Poptip(width="600" transfer trigger="hover")
            template(slot="title") {{ $t("domainsetting.explainServernameTitle") }}
            template(slot="content")
                template(v-if="notSupportIpDomain")
                    p {{ $t('domainsetting.explainServernameListItem')[0] }}
                template(v-else)
                    Row(v-for="(item, index) in $t('domainsetting.explainServernameListItem')" :key="index")
                        Col(span="24")
                            p {{ index + 1 }}. {{ item }}
                    Row
                        Col(span="24")
                            Table(:columns="tableColumns" :data="tableData" max-height="300")
            Button(shape="circle" icon="md-help" size="small")
</template>
<script>
import { getGroupIpDomainList } from "@/api/group.js";

export default {
    name: "ExplainServername",
    props: {
        explainPoptipWithTable: { type: Boolean, default: false },
        explainPoptipProps: { type: Object, default: () => ({}) },
        formData: { type: Object, default: () => ({}) },
    },
    data() {
        return {
            tableColumns: [
                {
                    title: this.$i18n.t("domainsetting.domainIpList"),
                    key: "ip",
                },
            ],
            tableData: [],
        };
    },
    watch: {
        "formData.groupName": {
            immediate: true,
            handler(newVal, oldVal) {
                if (newVal) this.fetchGroupIpDomainList();
            },
        },
    },
    methods: {
        fetchGroupIpDomainList() {
            const { groupName } = this.formData;
            if (!groupName) return;

            getGroupIpDomainList(groupName)
                .then((res) => {
                    this.tableData = res.map((item) => ({ ip: item }));
                })
                .catch((error) => console.log(error));
        },
    },
    computed: {
        notSupportIpDomain() {
            return !this.formData.groupName || this.tableData.length === 0;
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/PoptipInfos/ExplainServername.vue